import { useNavigate, useLocation } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import feather from 'feather-icons';

const BackButton = ({ fallback = '/', className = 'back-btn' }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const previousLocationRef = useRef(null);
    const canGoBackRef = useRef(false);

    useEffect(() => {
        feather.replace();

        // Track if we navigated to this page (meaning we CAN go back)
        canGoBackRef.current = true;
        previousLocationRef.current = location.pathname;
    }, [location.pathname]);

    const handleBack = () => {
        // Only navigate back if we actually navigated TO this page
        if (canGoBackRef.current && window.history.length > 1) {
            canGoBackRef.current = false; // Mark that we're going back
            navigate(-1);
        } else {
            // Navigate to fallback
            navigate(fallback);
        }
    };

    return (
        <button onClick={handleBack} className={className}>
            <i className="icon" data-feather="arrow-left"></i>
        </button>
    );
};

export default BackButton;
